<template>
  <div class="flex flex-col items-start py-4 mx-8 my-4 gap-6">
    <!-- Review Report Card -->
    <!-- <ReportCard
      title="Generate Review Report for Shallow Connected Workspaces"
      :stores="stores"
      :selectedLocations="selectedWIDs"
      :showDropdown="showReportDropdown"
      :isLoading="isReportLoading"
      :reportData="reportData"
      dropdownRef="reportDropdown"
      successMessage="Review report generated successfully!"
      @toggle-dropdown="toggleReportDropdown"
      @location-change="handleReportLocationChange"
      @generate="generateReportData('review')"
    /> -->

    <!-- Google Business Report Card -->
    <!-- <ReportCard
      title="Generate Google Business Report for Shallow Connected Workspaces"
      :stores="shallowWorkspaces"
      :selectedLocations="selectedGmbWIDs"
      :showDropdown="showGmbDropdown"
      :isLoading="isGmbLoading"
      :reportData="gmbReportData"
      dropdownRef="gmbDropdown"
      successMessage="Google Business report generated successfully!"
      @toggle-dropdown="toggleGmbDropdown"
      @location-change="handleGmbLocationChange"
      @generate="generateReportData('gmb')"
    /> -->

    <!-- <div
      v-for="(reportUrls, reportType) in groupedReports"
      :key="reportType"
      class="report-category mb-4 pl-4 border-l-4 border-blue-500"
    >
      <div class="report-title text-lg font-medium mb-2">
        {{ formatReportType(reportType) }}
      </div>
      <div class="report-images">
        <div
          v-for="(reportUrl, index) in reportUrls"
          :key="index"
          class="report-image mb-4"
        >
          <div class="actions flex gap-2 mt-2">
            <v-btn
              small
              color="primary"
              @click="viewFullReport(reportUrl, businessName, reportType)"
            >
              <v-icon small left>mdi-eye</v-icon> View
            </v-btn>
            <v-btn
              small
              color="success"
              @click="downloadSwotReport(reportUrl, businessName, reportType)"
            >
              <v-icon small left>mdi-download</v-icon> Download
            </v-btn>
          </div>
        </div>
      </div>
    </div> -->
    <!-- SWOT Analysis Reports -->
    <v-card
      class="w-full p-4"
      outlined
      v-if="groupedReports && Object.keys(groupedReports).length > 0"
    >
      <v-card-title class="text-h5">SWOT Analysis Reports</v-card-title>
      <v-card-text>
        <!-- Business Card - Parent container -->
        <div
          v-for="(reports, businessName) in groupedReports"
          :key="businessName"
          class="business-group mb-6 p-4 border rounded-lg bg-dark"
        >
          <div class="text-xl font-bold mb-3 text-white">
            {{ businessName }}
          </div>

          <!-- Flattened report items in a consistent grid -->
          <div class="reports-grid">
            <div
              v-for="(reportInfo, reportIndex) in getAllReportsForBusiness(
                businessName
              )"
              :key="reportIndex"
              class="report-card-wrapper p-2"
            >
              <div class="timestamp-row flex justify-between items-center mb-2">
                <!-- <span class="text-xs text-white">{{ formatTimestamp(reportInfo.timestamp) }}</span> -->
                <v-chip
                  x-small
                  :color="getReportTypeColor(reportInfo.reportType)"
                  text-color="white"
                  class="ml-2"
                >
                  {{ formatReportTypeShort(reportInfo.reportType) }}
                  {{ reportInfo.index + 1 }}
                </v-chip>
              </div>

              <div class="report-item-card bg-gray-800 rounded overflow-hidden">
                <img
                  :src="reportInfo.url"
                  class="max-w-full contained-image"
                  alt="SWOT Analysis Report"
                />
                <div class="actions flex justify-center gap-2 p-2">
                  <v-btn
                    small
                    color="primary"
                    v-if="reportInfo.maps_link"
                    @click="copyMapsLink(reportInfo.maps_link)"
                  >
                    Maps Link
                  </v-btn>
                  <v-btn
                    small
                    color="primary"
                    @click="
                      viewFullReport(
                        reportInfo.url,
                        businessName,
                        reportInfo.reportType,
                        true
                      )
                    "
                  >
                    <v-icon small left>mdi-eye</v-icon> View
                  </v-btn>
                  <v-btn
                    small
                    color="success"
                    @click="
                      downloadSwotReport(
                        reportInfo.url,
                        businessName,
                        reportInfo.reportType
                      )
                    "
                  >
                    <v-icon small left>mdi-download</v-icon> Download
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- Review Report Status Card -->
    <!-- <v-card class="w-full p-4" outlined v-if="workspaceReports.length > 0">
      <v-card-title class="text-h5">Reviews Snapshots</v-card-title>
      <v-card-text>
        <div class="report-items">
          <div
            v-for="workspace in workspaceReports"
            :key="workspace.wid"
            class="report-item mb-4 p-3 border rounded"
          >
            <div class="text-lg font-bold">{{ workspace.name }}</div>
            <div class="status mb-2">
              Status:
              <span :class="getStatusClass(workspace.status)">{{
                formatStatus(workspace.review_report_status)
              }}</span>
            </div>
            <div
              class="actions flex gap-2"
              v-if="
                workspace.review_report_status === 'completed' &&
                workspace.report_url
              "
            >
              <v-btn small color="primary" @click="viewReport(workspace)">
                <v-icon small left>mdi-eye</v-icon> View
              </v-btn>
              <v-btn small color="success" @click="downloadReport(workspace)">
                <v-icon small left>mdi-download</v-icon> Download
              </v-btn>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card> -->

    <!-- Report Preview Dialog -->
    <v-dialog v-model="showReportDialog" max-width="1200" class="report-dialog">
      <v-card>
        <v-card-title class="text-h5">
          {{ currentReportTitle }}
          <v-spacer></v-spacer>
          <v-btn icon @click="showReportDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="text-center">
          <img :src="currentReportUrl" class="max-w-full" alt="Report" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { auth, colUsers, db, functions } from "@/utils/firebase.utils";
import { httpsCallable } from "firebase/functions";
import {
  getDoc,
  doc,
  updateDoc,
  setDoc,
  collection,
  onSnapshot,
} from "firebase/firestore";
import ReportCard from "@/components/ui/AdminReportCard.vue";

export default {
  components: {
    ReportCard,
  },
  data() {
    return {
      shallowWorkspaces: [],
      reportsCount: 2,
      workspaceReports: [],
      reportListener: null,
      // Report preview dialog
      showReportDialog: false,
      selectedWorkspace: null,
      // For SWOT analysis reports
      groupedReports: null,
      currentReportUrl: null,
      currentReportTitle: null,
      // Review report data
      selectedReportWIDs: [],
      showReportDropdown: false,
      isReportLoading: false,
      reportData: null,

      // GMB report data
      selectedGmbWIDs: [],
      showGmbDropdown: false,
      isGmbLoading: false,
      gmbReportData: null,
      stores: [],
      selectedWIDs: [],
    };
  },
  watch: {
    globalStores: {
      handler() {
        this.fetchStores();
        this.processSwotReports();
      },
      deep: true,
    },
  },
  methods: {
    // Add these additional methods to the methods section
    getAllReportsForBusiness(businessName) {
      const allReports = [];
      const businessReports = this.groupedReports[businessName];

      // Loop through all report types for this business
      Object.keys(businessReports).forEach((reportType) => {
        // Add each report with its metadata
        businessReports[reportType].forEach((report, index) => {
          allReports.push({
            ...report,
            reportType: reportType,
            index: index,
          });
        });
      });

      return allReports;
    },

    formatReportTypeShort(reportType) {
      switch (reportType) {
        case "inconsistent_naming":
          return "Naming";
        case "maps_missing_owner_posts":
          return "Posts";
        case "fly_reviews_insights_table":
          return "Reviews";
        case "maps_missing_phone_numbers":
          return "Phone Number";
        case "fly_profiles_description_dialog":
          return "Descripton";
        case "fly_profiles_description_dialog_fallback":
          return "Description";

        default:
          return reportType.split("_")[0];
      }
    },
    // Download SWOT report
    async downloadSwotReport(reportUrl, businessName, reportType) {
      try {
        // Create a new XMLHttpRequest to get the image as a blob
        const xhr = new XMLHttpRequest();
        xhr.open("GET", reportUrl, true);
        xhr.responseType = "blob";

        xhr.onload = async () => {
          if (xhr.status === 200) {
            // Create a blob URL for the image
            const blob = xhr.response;
            const blobUrl = URL.createObjectURL(blob);

            // Create and trigger download link
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `${businessName}_${reportType}.png`;
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();

            // Clean up
            setTimeout(() => {
              URL.revokeObjectURL(blobUrl);
              document.body.removeChild(link);
            }, 100);

            this.$snackbar?.show("Report downloaded successfully!");
          } else {
            throw new Error("Failed to download image");
          }
        };

        xhr.onerror = () => {
          throw new Error("Network error occurred");
        };

        xhr.send();
      } catch (error) {
        console.error("Error downloading report:", error);
        this.$snackbar?.show("Failed to download report. Please try again.");
      }
    },
    // Format the status to be more user-friendly
    formatStatus(status) {
      console.log("status", status);
      switch (status) {
        case "in_progress":
          return "In Progress";
        case "completed":
          return "Completed";
        case "failed":
          return "Failed";
        default:
          return status.charAt(0).toUpperCase() + status.slice(1);
      }
    },

    // Get CSS class based on status
    getStatusClass(status) {
      console.log("status", status);
      switch (status) {
        case "in_progress":
          return "text-blue-500";
        case "completed":
          return "text-green-500";
        case "failed":
          return "text-red-500";
        default:
          return "";
      }
    },
    // Add these methods to the methods section
    getReportTypeClass(reportType) {
      switch (reportType) {
        case "inconsistent_naming":
          return "bg-red-600";
        case "maps_missing_owner_posts":
          return "bg-blue-600";
        case "fly_reviews_insights_table":
          return "bg-green-600";
        default:
          return "bg-gray-600";
      }
    },

    getReportTypeColor(reportType) {
      switch (reportType) {
        case "inconsistent_naming":
          return "red";
        case "maps_missing_owner_posts":
          return "blue";
        case "fly_reviews_insights_table":
          return "green";
        default:
          return "grey";
      }
    },

    getReportItemNumber(index) {
      return `Item ${index + 1}`;
    },

    formatTimestamp(timestamp) {
      if (!timestamp) return "";

      try {
        const date = new Date(timestamp);
        return date.toLocaleString();
      } catch (e) {
        return timestamp;
      }
    },

    // Update the processSwotReports method to handle the new structure
    async processSwotReports() {
      // Check if the data exists
      if (!this.globalStores) return;

      const workspaceData = (
        await getDoc(doc(colUsers, this.currentUID, "fly_workspaces", this.WID))
      ).data();

      if (workspaceData?.swot_analysis_report) {
        // Initialize a new object for grouping by business name
        this.groupedReports = {};

        // Iterate through each report type
        Object.keys(workspaceData.swot_analysis_report).forEach(
          (reportType) => {
            const reportTypeData =
              workspaceData.swot_analysis_report[reportType];

            // Check if reportTypeData is an array (numeric indices)
            if (Array.isArray(reportTypeData)) {
              // Process array format
              reportTypeData.forEach((item) => {
                if (item.businessName) {
                  // Initialize business object if it doesn't exist
                  if (!this.groupedReports[item.businessName]) {
                    this.groupedReports[item.businessName] = {};
                  }

                  // Initialize report type array if it doesn't exist
                  if (!this.groupedReports[item.businessName][reportType]) {
                    this.groupedReports[item.businessName][reportType] = [];
                  }

                  // Add full item data to the reports array
                  this.groupedReports[item.businessName][reportType].push(item);
                }
              });
            } else if (typeof reportTypeData === "object") {
              // Process object format with numeric keys
              Object.keys(reportTypeData).forEach((index) => {
                const item = reportTypeData[index];

                if (item.businessName) {
                  // Initialize business object if it doesn't exist
                  if (!this.groupedReports[item.businessName]) {
                    this.groupedReports[item.businessName] = {};
                  }

                  // Initialize report type array if it doesn't exist
                  if (!this.groupedReports[item.businessName][reportType]) {
                    this.groupedReports[item.businessName][reportType] = [];
                  }

                  // Add full item data to the reports array
                  this.groupedReports[item.businessName][reportType].push(item);
                }
              });
            }
          }
        );
      }

      console.log("groupedReports", this.groupedReports);
    },
    // Format report type to a more readable format
    formatReportType(type) {
      switch (type) {
        case "fly_reviews_insights_table":
          return "Reviews Insights";
        case "inconsistent_naming":
          return "Inconsistent Naming";
        case "maps_missing_owner_posts":
          return "Missing Owner Posts";
        default:
          return type
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
      }
    },
    copyMapsLink(url) {
      // open link in new tab
      window.open(url, "_blank");
      // copy the link to the clipboard
      // navigator.clipboard
      //   .writeText(url)
      //   .then(() => {
      //     // Optional: Show a success message
      //     this.$snackbar.show({
      //       message: "Link copied to clipboard.",
      //       color: "success",
      //     });
      //   })
      //   .catch((err) => {
      //     console.error("Failed to copy link: ", err);
      //     this.$snackbar.show({
      //       message: "Failed to copy link",
      //       color: "error",
      //     });
      //   });
    },

    // View full report in dialog and/or new tab
    viewFullReport(reportUrl, businessName, reportType, openNewTab = false) {
      // Always set dialog data
      this.currentReportUrl = reportUrl;
      this.currentReportTitle = `${businessName} - ${this.formatReportType(
        reportType
      )}`;
      // TODO uncomment this to open in dialog
      // this.showReportDialog = true;

      // Optionally open in new tab
      if (openNewTab) {
        window.open(reportUrl, "_blank");
      }
    },

    // Process and group SWOT analysis reports
    // async processSwotReports() {
    //   // Check if the data exists
    //   if (!this.globalStores) return;

    //   const groupedData = {};
    //   const workspaceData = (
    //     await getDoc(doc(colUsers, this.currentUID, "fly_workspaces", this.WID))
    //   ).data();
    //   console.log("workspaceData", workspaceData);
    //   console.log(
    //     "type of groupedData",
    //     typeof workspaceData.swot_analysis_report
    //   );

    //   // group data by business name

    //   if (workspaceData?.swot_analysis_report) {
    //     // Initialize a new object for grouping by business name
    //     this.groupedReports = {};

    //     // Iterate through each report type
    //     Object.keys(workspaceData.swot_analysis_report).forEach(
    //       (reportType) => {
    //         // Iterate through each business in this report type
    //         Object.keys(workspaceData.swot_analysis_report[reportType]).forEach(
    //           (businessName) => {
    //             // Initialize business object if it doesn't exist
    //             if (!this.groupedReports[businessName]) {
    //               this.groupedReports[businessName] = {};
    //             }

    //             // Initialize report type array if it doesn't exist
    //             if (!this.groupedReports[businessName][reportType]) {
    //               this.groupedReports[businessName][reportType] = [];
    //             }

    //             // Get the value (could be a single URL or array)
    //             const reportData =
    //               workspaceData.swot_analysis_report[reportType][businessName];

    //             // If reportData is an array, add all items, otherwise add single item
    //             if (Array.isArray(reportData)) {
    //               this.groupedReports[businessName][reportType].push(
    //                 ...reportData
    //               );
    //             } else {
    //               this.groupedReports[businessName][reportType].push(
    //                 reportData
    //               );
    //             }
    //           }
    //         );
    //       }
    //     );
    //   }
    //   console.log("groupedData", groupedData);

    //   console.log("groupedReports", this.groupedReports);
    // },
    // ... existing code ...

    // View report in dialog
    viewReport(workspace) {
      this.selectedWorkspace = workspace;
      this.currentReportUrl = null;
      this.currentReportTitle = null;
      this.showReportDialog = true;
    },
    async fetchStores() {
      this.stores = [];
      this.selectedWIDs = [];
      this.globalStores.forEach((storeData) => {
        this.stores.push({
          ...storeData,
          id: storeData.id,
          wid: storeData.id,
          type: "store",
          checked: true,
          isReview: true,
          isSelectable: true,
          tooltipMessage: "",
        });
        this.selectedWIDs.push(storeData.id);
      });

      console.log("stores", this.stores);
    },

    // Download report
    async downloadReport(workspace) {
      try {
        // Create a new XMLHttpRequest to get the image as a blob
        const xhr = new XMLHttpRequest();
        xhr.open("GET", workspace.report_url, true);
        xhr.responseType = "blob";

        xhr.onload = async () => {
          if (xhr.status === 200) {
            // Create a blob URL for the image
            const blob = xhr.response;
            const blobUrl = URL.createObjectURL(blob);

            // Create and trigger download link
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `${workspace.name}_review_report.png`;
            link.style.display = "none";
            document.body.appendChild(link);
            link.click();

            // Clean up
            setTimeout(() => {
              URL.revokeObjectURL(blobUrl);
              document.body.removeChild(link);
            }, 100);

            // Update download status in Firestore
            await this.updateDownloadStatus(workspace.wid);
            this.$snackbar?.show("Report downloaded successfully!");
          } else {
            throw new Error("Failed to download image");
          }
        };

        xhr.onerror = () => {
          throw new Error("Network error occurred");
        };

        xhr.send();
      } catch (error) {
        console.error("Error downloading report:", error);
        this.$snackbar?.show("Failed to download report. Please try again.");
      }
    },

    // Update download status in Firestore
    async updateDownloadStatus(wid) {
      try {
        const docRef = doc(
          colUsers,
          this.currentUID,
          "fly_workspaces",
          this.WID
        );
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          if (
            data.shallow_report_status &&
            data.shallow_report_status.workspaces
          ) {
            const updatedWorkspaces = data.shallow_report_status.workspaces.map(
              (ws) => {
                if (ws.wid === wid) {
                  return {
                    ...ws,
                    download_status: "downloaded",
                    downloaded_at: new Date().toISOString(),
                  };
                }
                return ws;
              }
            );

            await updateDoc(docRef, {
              "shallow_report_status.workspaces": updatedWorkspaces,
            });
          }
        }
      } catch (error) {
        console.error("Error updating download status:", error);
      }
    },

    // Setup real-time listener for report status
    setupReportStatusListener() {
      if (this.reportListener) {
        this.reportListener();
      }

      const docRef = doc(colUsers, this.currentUID, "fly_workspaces", this.WID);
      this.reportListener = onSnapshot(
        docRef,
        (docSnap) => {
          if (docSnap.exists()) {
            const data = docSnap.data();
            if (
              data.shallow_report_status &&
              data.shallow_report_status.workspaces
            ) {
              this.workspaceReports = [
                ...data.shallow_report_status.workspaces,
              ];
            } else {
              this.workspaceReports = [];
            }
          }
        },
        (error) => {
          console.error("Error setting up report listener:", error);
        }
      );
      console.log("workspaceReports", this.workspaceReports);
    },

    async fetchShallowWorkspaces() {
      try {
        this.shallowWorkspaces = [];
        this.selectedReportWIDs = [];
        this.selectedGmbWIDs = [];
        const adminDocRef = doc(
          colUsers,
          this.currentUID,
          "fly_workspaces",
          this.WID
        );
        const adminDocSnap = await getDoc(adminDocRef);
        let workspaceStatusMap = {};
        // If admin document exists and has report status, create a map for quick lookup
        if (adminDocSnap.exists()) {
          const adminData = adminDocSnap.data();
          if (
            adminData.swot_analysis_report
            // &&            adminData.shallow_report_status.workspaces
          ) {
            // Create a map of workspace ID to status for quick lookup
            adminData.shallow_report_status.workspaces.forEach((workspace) => {
              workspaceStatusMap[workspace.wid] = workspace.status;
            });
          }
        }

        // Process the existing store data
        this.globalStores.forEach((storeData) => {
          if (storeData.shallowConnect) {
            const reportStatus = workspaceStatusMap[storeData.id];
            let tooltipMessage = "";
            // Set tooltip message based on report status
            if (reportStatus) {
              switch (reportStatus) {
                case "in_progress":
                  tooltipMessage = "Report generation in progress";
                  break;
                case "completed":
                  tooltipMessage = "Report generation completed";
                  break;
                case "failed":
                  tooltipMessage = "Report generation failed";
                  break;
                default:
                  tooltipMessage = `Status: ${reportStatus}`;
              }
            }
            // Add computed properties that aren't stored in Firestore
            this.shallowWorkspaces.push({
              ...storeData,
              id: storeData.id,
              wid: storeData.id,
              type: "store",
              checked:
                reportStatus == "in_progress" || reportStatus == "completed"
                  ? false
                  : true,
              isReview: true,
              tooltipMessage:
                reportStatus && reportStatus == "in_progress"
                  ? "Report generation in progress"
                  : reportStatus && reportStatus == "completed"
                  ? "Report generation completed"
                  : reportStatus && reportStatus == "failed"
                  ? "Report generation failed"
                  : false,
              isSelectable:
                (reportStatus && reportStatus == "in_progress") ||
                reportStatus == "completed"
                  ? false
                  : true,
            });
            this.selectedReportWIDs.push(storeData.id);
            this.selectedGmbWIDs.push(storeData.id);
          }
        });
        console.log("shallowWorkspaces", this.shallowWorkspaces);
      } catch (error) {
        console.error("Error fetching shallow workspaces:", error);
      }
    },

    toggleReportDropdown(event) {
      this.showReportDropdown = !this.showReportDropdown;
      if (this.showReportDropdown) this.showGmbDropdown = false;
    },

    toggleGmbDropdown(event) {
      this.showGmbDropdown = !this.showGmbDropdown;
      if (this.showGmbDropdown) this.showReportDropdown = false;
    },

    handleReportLocationChange(selectedWIDs) {
      console.log("selectedWIDs", selectedWIDs);
      this.selectedReportWIDs = selectedWIDs;
      this.selectedWIDs = selectedWIDs;
    },

    handleGmbLocationChange(selectedWIDs) {
      console.log("selectedWIDs", selectedWIDs);
      this.selectedGmbWIDs = selectedWIDs;
    },

    async generateReportData(type) {
      const docRef = doc(colUsers, this.currentUID, "fly_workspaces", this.WID);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        throw new Error("Workspace document not found");
      }

      const workspaceData = docSnap.data();

      // Check if swot_brands exists
      if (!workspaceData.swot_brands) {
        throw new Error("No swot_brands data found");
      }

      // Find matching brands that have at least one of the selected locations
      const matchingBrands = [];
      let matchingBrand = null;
      let matchingBrandKey = null;

      let hasMatchingLocations = false;
      for (const brandKey in workspaceData.swot_brands) {
        hasMatchingLocations = false;
        const brand = workspaceData.swot_brands[brandKey];

        // Check if this brand has any of the selected locations
        const brandLocations = brand.locations || [];
        console.log("brandLocations", brandLocations);
        console.log("selectedWIDs", this.selectedWIDs);
        hasMatchingLocations = brandLocations.some((loc) =>
          this.selectedWIDs.includes(loc)
        );
        console.log("hasMatchingLocations", hasMatchingLocations);
        if (hasMatchingLocations) {
          matchingBrandKey = brandKey;
          matchingBrand = brand;
          break; // Use the first matching brand
        }
      }

      if (!hasMatchingLocations) {
        this.$snackbar?.show("No matching brands found for selected locations");
        return;
      }
      const payload = {
        ...matchingBrand.payload,
      };

      console.log("Sending to cloudrun:", payload);
      try {
        // const response = await fetch(`http://localhost:3000/swotAnalysis`, {
        console.log(
          "process.env.VUE_APP_CLOUDRUN_KEY",
          process.env.VUE_APP_CLOUDRUN_KEY
        );
        const response = await fetch(
          `${process.env.VUE_APP_CLOUDRUN_KEY}/swotAnalysis`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            // pass matchingBrand as body
            body: JSON.stringify(payload),
          }
        );
      } catch (error) {
        console.error("Error making post request to cloud run service:", error);
      }
      return;
    },

    async checkAdminStatus() {
      try {
        let userRef = doc(db, "users", this.currentUID);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const userData = userSnap.data();
          if (!("super_admin" in userData && userData.super_admin)) {
            this.$snackbar?.show("Direct access is prohibited");
            this.$router.push("/calendar");
          }
        }
      } catch (err) {
        console.error("Error checking admin status ", err);
        this.$snackbar?.show("Direct access is prohibited");
        this.$router.push("/calendar");
      }
    },
  },
  async mounted() {
    this.currentUID = auth.currentUser?.uid;

    if (!this.currentUID) {
      this.$snackbar?.show("Please login to access this page");
      this.$router.push("/login");
      return;
    }
    if (this.globalStores?.length) {
      await this.fetchStores();
      this.processSwotReports(); // Process SWOT reports when stores are loaded
    }

    // Setup the real-time listener for report status
    this.setupReportStatusListener();

    // await this.checkAdminStatus();
  },
  beforeDestroy() {
    // Close dropdowns if open
    this.showReportDropdown = false;
    this.showGmbDropdown = false;

    // Clean up the report listener
    if (this.reportListener) {
      this.reportListener();
    }
  },
};
</script>

<style scoped>
.location-dropdown {
  position: relative;
}

.report-item {
  border-color: #e0e0e0;
}

.report-items {
  max-height: 400px;
  overflow-y: auto;
}

.business-group {
  /* background-color: #f9f9f9; */
}

.report-image img {
  cursor: pointer;
  transition: transform 0.2s;
}

.report-image img:hover {
  transform: scale(1.02);
}

:deep(.report-dialog) {
  z-index: 9999 !important;
}

.contained-image {
  max-height: 300px;
  width: 100%;
  object-fit: contain;
}

.business-group {
  /* background-color: #f9f9f9; */
  border-radius: 8px;
}

.report-category {
  transition: transform 0.2s;
}

.report-category:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.report-dialog {
  z-index: 9999 !important;
}
.business-group {
  background-color: #1e1e1e;
}

.reports-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.report-item-card {
  transition: transform 0.2s;
  border: 1px solid #444;
}

.report-item-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.contained-image {
  max-height: 250px;
  width: 100%;
  object-fit: contain;
  background-color: white;
}

.timestamp-row {
  min-height: 24px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .reports-grid {
    grid-template-columns: 2fr;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .report-types {
    grid-template-columns: 1fr;
  }
}
</style>
